/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![UserMinusIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABZUlEQVR4nOVUO07DQBR0waelAAoEdU5AbSGaFH4fF+v3IpDo0tOQkg4BJ+AKiSJxAxQSuAItVTpAgAgfgQhaJ4oC0Ro7TgrEk6axtTPjmbf2vH8xRLKGLHVgfbRAllNEU5gYOZDeImv3O+TOvsstgCz1UfI+SGu5BSCOxCHA8jBVASC9zy2AtlBnRFLNL4CmYAsddS83Ybi16k1sTUlrNvMYJNWJkU91rEsgqQDrObC0gfQDWd+B9RpYzxB1NwhKi5mJi8XiPLIcIcmLe0UHeEXWfd/3Z9KRG7MErJcpiLs/Lt0F0c5CInm5XJ5FkkZmch6sbcMYM+cUiGMZl5z7CCN1FpomcyB9A9I9RF3xsozdljQOgaSSiXggwNoccnnlFMGe81SLQNIaEpB2/w/5hBhtuA6F4fZy3BdJ69evZW0ORaTPvYdyEnDJT3B1MFZEyHqIrJ0gjNYDkk1k/Uwo+ngskT85X0RzlaVrrJw+AAAAAElFTkSuQmCC)
 */
export const UserMinusIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        d="M11.53 11A9.53 9.53 0 0 0 2 20.53c0 .81.66 1.47 1.47 1.47h.22c.24 0 .44-.17.5-.4.29-1.12.84-2.17 1.32-2.91.14-.21.43-.1.4.15l-.25 2.61c-.03.3.2.55.5.55h7.63c.12 0 .17-.31.06-.36C12.82 21.14 12 20.22 12 19a3 3 0 0 1 3-3h5.02c.38 0 .61-.4.4-.72A9.52 9.52 0 0 0 12.47 11h-.94ZM12 10a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
      <path
        d="M15 18a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2h-8Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
    </svg>
  );
};
